module.exports = __webpack_public_path__ + "img/pr-5.2b2360c0.png";